import React from 'react'

const SupplyOmniHome: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_703_38381)" />
    <path
      d="M47.9252 33.3037L47.9158 33.2996L22.8916 22.9203C22.6811 22.8322 22.4521 22.7976 22.225 22.8197C21.9979 22.8418 21.7798 22.9198 21.5902 23.0468C21.39 23.1781 21.2254 23.357 21.1115 23.5676C20.9976 23.7782 20.9378 24.0138 20.9375 24.2533V30.8914C20.9376 31.2187 21.0519 31.5357 21.2607 31.7878C21.4695 32.04 21.7597 32.2113 22.0813 32.2724L35.7295 34.7961C35.7831 34.8062 35.8315 34.8348 35.8663 34.8768C35.9012 34.9189 35.9202 34.9717 35.9202 35.0263C35.9202 35.0809 35.9012 35.1338 35.8663 35.1758C35.8315 35.2179 35.7831 35.2464 35.7295 35.2566L22.0818 37.7802C21.7603 37.8412 21.4702 38.0123 21.2613 38.2642C21.0524 38.5161 20.9379 38.8329 20.9375 39.1601V45.7994C20.9373 46.028 20.994 46.2531 21.1023 46.4545C21.2106 46.6558 21.3672 46.8272 21.558 46.9531C21.7876 47.1056 22.057 47.1871 22.3326 47.1875C22.5242 47.1873 22.7139 47.1488 22.8904 47.0744L47.9141 36.7543L47.9252 36.749C48.262 36.6042 48.549 36.3639 48.7507 36.0577C48.9524 35.7515 49.0599 35.393 49.0599 35.0263C49.0599 34.6597 48.9524 34.3011 48.7507 33.9949C48.549 33.6888 48.262 33.4484 47.9252 33.3037Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_703_38381"
        x1="-1.56654e-06"
        y1="4.96155"
        x2="70"
        y2="66.9615"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E5A100" />
        <stop offset="1" stopColor="#F14B12" />
      </linearGradient>
    </defs>
  </svg>
)

export default SupplyOmniHome
